import { default as EffectGiftjbV2oZfD85Meta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectGift.vue?macro=true";
import { default as EffectHeadwearlACxr8K8ecMeta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectHeadwear.vue?macro=true";
import { default as MicEmojiAnimationOyh2w3XTChMeta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/animation/MicEmojiAnimation.vue?macro=true";
import { default as MicListnY9dvS3IKsMeta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/audio/MicList.vue?macro=true";
import { default as RTCAudioTk9tKNgGqxMeta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/audio/RTCAudio.vue?macro=true";
import { default as MicEmojiPopupvKOjmQ8icjMeta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/popup/MicEmojiPopup.vue?macro=true";
import { default as AudioXhVh4bPXy2Meta } from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/RoomApp/Audio.vue?macro=true";
export default [
  {
    name: EffectGiftjbV2oZfD85Meta?.name ?? "Room-components-animation-EffectGift",
    path: EffectGiftjbV2oZfD85Meta?.path ?? "/Room/components/animation/EffectGift",
    meta: EffectGiftjbV2oZfD85Meta || {},
    alias: EffectGiftjbV2oZfD85Meta?.alias || [],
    redirect: EffectGiftjbV2oZfD85Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectGift.vue").then(m => m.default || m)
  },
  {
    name: EffectHeadwearlACxr8K8ecMeta?.name ?? "Room-components-animation-EffectHeadwear",
    path: EffectHeadwearlACxr8K8ecMeta?.path ?? "/Room/components/animation/EffectHeadwear",
    meta: EffectHeadwearlACxr8K8ecMeta || {},
    alias: EffectHeadwearlACxr8K8ecMeta?.alias || [],
    redirect: EffectHeadwearlACxr8K8ecMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectHeadwear.vue").then(m => m.default || m)
  },
  {
    name: MicEmojiAnimationOyh2w3XTChMeta?.name ?? "Room-components-animation-MicEmojiAnimation",
    path: MicEmojiAnimationOyh2w3XTChMeta?.path ?? "/Room/components/animation/MicEmojiAnimation",
    meta: MicEmojiAnimationOyh2w3XTChMeta || {},
    alias: MicEmojiAnimationOyh2w3XTChMeta?.alias || [],
    redirect: MicEmojiAnimationOyh2w3XTChMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/animation/MicEmojiAnimation.vue").then(m => m.default || m)
  },
  {
    name: MicListnY9dvS3IKsMeta?.name ?? "Room-components-audio-MicList",
    path: MicListnY9dvS3IKsMeta?.path ?? "/Room/components/audio/MicList",
    meta: MicListnY9dvS3IKsMeta || {},
    alias: MicListnY9dvS3IKsMeta?.alias || [],
    redirect: MicListnY9dvS3IKsMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/audio/MicList.vue").then(m => m.default || m)
  },
  {
    name: RTCAudioTk9tKNgGqxMeta?.name ?? "Room-components-audio-RTCAudio",
    path: RTCAudioTk9tKNgGqxMeta?.path ?? "/Room/components/audio/RTCAudio",
    meta: RTCAudioTk9tKNgGqxMeta || {},
    alias: RTCAudioTk9tKNgGqxMeta?.alias || [],
    redirect: RTCAudioTk9tKNgGqxMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/audio/RTCAudio.vue").then(m => m.default || m)
  },
  {
    name: MicEmojiPopupvKOjmQ8icjMeta?.name ?? "Room-components-popup-MicEmojiPopup",
    path: MicEmojiPopupvKOjmQ8icjMeta?.path ?? "/Room/components/popup/MicEmojiPopup",
    meta: MicEmojiPopupvKOjmQ8icjMeta || {},
    alias: MicEmojiPopupvKOjmQ8icjMeta?.alias || [],
    redirect: MicEmojiPopupvKOjmQ8icjMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/Room/components/popup/MicEmojiPopup.vue").then(m => m.default || m)
  },
  {
    name: AudioXhVh4bPXy2Meta?.name ?? "RoomApp-Audio",
    path: AudioXhVh4bPXy2Meta?.path ?? "/RoomApp/Audio",
    meta: AudioXhVh4bPXy2Meta || {},
    alias: AudioXhVh4bPXy2Meta?.alias || [],
    redirect: AudioXhVh4bPXy2Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/pages/RoomApp/Audio.vue").then(m => m.default || m)
  }
]